module.exports = __webpack_public_path__ + "static/media/mainChart1.12a23e71.png";